import {request,setAuthInHeader} from "@/api/request";

const state = {
    countries: [],
};

const getters  = {
    getCountries: state => state.countries,
};

const mutations = {
    updateCountries(state, obj) {
        state.countries = obj.data;
    }
};

const actions = {
    setLocale({commit, rootState}, {}) {
        let countries = [
            {c_idx:1, c_number: "82", c_code: "KR", c_location: "KO", c_name_kr: "대한민국", c_name_us: "Korea, Republic Of", lang_name_kr: '한국어'},
            {c_idx:2, c_number: "81", c_code: "JP", c_location: "JA", c_name_kr: "일본", c_name_us: "Japan", lang_name_kr: '일본어'},
            {c_idx:3, c_number: null, c_code: "CN", c_location: null, c_name_kr: "중화인민공화국", c_name_us: "China", lang_name_kr: '중국어'},
            {c_idx:30, c_number: "1", c_code: "US", c_location: "EN", c_name_kr: "미국", c_name_us: "United States", lang_name_kr: '영어'},
            {c_idx:81, c_number: null, c_code: "ES", c_location: null, c_name_kr: "스페인", c_name_us: "Spain", lang_name_kr: '스페인어'},

        ]
        commit('updateCountries', {data: countries})
    },
};

export default { namespaced: true, state, getters, mutations, actions }